import PropTypes from "prop-types";
import React from "react";
import {
  StyleSheet,
  View,
  TouchableOpacity,
  Platform,
  ScrollView,
} from "react-native";
import ENV from "app/utils/ENV";
import colorHelpers from "app/utils/colorHelpers";
import Text from "app/components/Text";
import { styleSheet, colors, sizes, WIDTH } from "app/utils/styleSheet";

import { MaterialCommunityIcons, AntDesign, Feather } from "@expo/vector-icons";

export default class About extends React.Component {
  render() {
    return (
      <View style={styles.wrapper}>
        <ScrollView>
          <TouchableOpacity onPress={this.props.onHide}>
            <View style={styles.topHeader}>
              <Text bold style={{ fontSize: sizes.large }}>
                Mandelbrot
              </Text>
              <Text>
                <Feather style={{ fontSize: sizes.large }} name="x" />
              </Text>
            </View>
          </TouchableOpacity>

          <View style={[styles.row, { marginBottom: sizes.large }]}>
            <Text>
              This project is intended to help you actualize your values. By
              aligning daily habits with long-term aspirations, you can
              gradually achieve your goals and refine your understanding of what
              they mean to you.
            </Text>
          </View>

          <Text style={styles.header}>Values</Text>

          <View style={styles.row}>
            <Text>Value items represent the hierarchy of your behavior.</Text>
          </View>
          <View style={styles.row}>
            <Text>
              Values higher up in the tree should be things you aspire towards,
              ambitious goals or moral principles that resonate and inspire you.
            </Text>
          </View>
          <View style={styles.row}>
            <Text>
              Break those values down into sub-values: things that can serve the
              parent value by either actualizing it in your life, or giving you
              more understanding of what it truly means to you.
            </Text>
          </View>
          <View style={styles.row}>
            <Text>
              Then break those sub-values down into actionable habits that you
              can engage with everyday. These in turn should help you to
              actualize or understand their parents as well.
            </Text>
          </View>
          <View style={styles.row}>
            <Text>
              Or if you're more of a bottom-up thinker, start by defining habits
              or small actionable tasks you'd like to track, and then abstract
              upwards asking yourself on each level "Why is this action
              important to me?" until you've reached a high-level value that
              resonates.
            </Text>
          </View>

          <View style={styles.gap} />

          <Text style={styles.header}>Notes</Text>

          <View style={styles.row}>
            <Text>Notes are also things.</Text>
          </View>

          <View style={styles.gap} />

          <Text style={styles.header}>Chapters</Text>

          <View style={styles.row}>
            <Text>Chapters are time-frames.</Text>
          </View>
          <View style={styles.row}>
            <Text>
              Think of "moments" as thumb-tacks you can use to "pin" something
              to a chapter.
            </Text>
          </View>
          <View style={styles.row}>
            <Text>You can pin a value or note.</Text>
          </View>
          <View style={styles.row}>
            <Text>
              Or you can pin an event, like a progression or a completion.
            </Text>
          </View>
          <View style={styles.row}>
            <Text>Moments are not the "source of truth," values are.</Text>
          </View>

          <View style={styles.gap} />
          <View style={styles.gap} />

          <View style={styles.row}>
            <Text>
              Might be more fun to use some filler-content to explain this info.
            </Text>
          </View>

          <View style={styles.gap} />
        </ScrollView>
      </View>
    );
  }
  // <AntDesign
  //   name={"enter"}
  //   color={colors.foreground}
  // />
}

const styles = StyleSheet.create({
  wrapper: {
    width: ENV.WEB ? 500 : WIDTH,
    borderRadius: sizes.smallBorderRadius,
    position: "fixed",
    position: "absolute",
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: colorHelpers.hexToRgbaString(colors.empty, 0.91),
    backgroundColor: colors.fill,
    padding: sizes.large,
    paddingTop: ENV.WEB ? 0 : 50,
    borderLeftWidth: 1,
    borderColor: colors.trim,
  },
  topHeader: {
    height: 65,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    // borderWidth: 2,
    borderColor: "red",
    paddingHorizontal: sizes.small,
  },
  header: {
    // borderBottomWidth: 1,
    borderColor: colors.trim,
    fontWeight: "bold",
    marginBottom: sizes.base,
    borderRadius: sizes.smallBorderRadius,
    backgroundColor: colorHelpers.hexToRgbaString(colors.fill, 0.8),
    backgroundColor: colorHelpers.hexToRgbaString(colors.trim, 0.6),
    padding: sizes.small,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    // alignItems: "center",
    marginBottom: sizes.base,
    paddingHorizontal: sizes.small,
    // borderBottomWidth: 1,
    borderColor: colors.fill,
    paddingBottom: sizes.small,
  },
  gap: {
    height: sizes.large,
  },
  icon: {
    fontSize: sizes.default,
    color: colors.foreground,
    // backgroundColor: colorHelpers.hexToRgbaString(colors.fill, 0.8),
    backgroundColor: colorHelpers.hexToRgbaString(colors.trim, 0.6),
    borderRadius: sizes.smallBorderRadius,
    padding: 3,
  },
  subtext: {
    opacity: 0.6,
    fontStyle: "italic",
  },
});
